import AOS from 'aos';

AOS.init({
  once: true,
  offset: 100,
  startEvent: 'load',
});
AOS.refresh(true);

$(window).on('load', function () {
  // get current position and scroll 1px down to prevent that a blank page is shown at certain points because the aos elements fall just between the offset
  var y = $(window).scrollTop();
  $(window).scrollTop(y + 1);
});
